export default "__VITE_ASSET__ZarPEtgh__"